export default "__VITE_ASSET__44a5b2da__"